import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import ToastContainer from './Toast';

const ToastManager: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return <ToastContainer toasts={toasts} onRemove={removeToast} />;
};

export default ToastManager;
